enum MessageUser {
  AI = 'ai',
  HUMAN = 'human',
}

export default MessageUser;
